const configSocial = {
  twitter: {
    site: null,
    creator: null,
    link: null,
  },

  facebook: {
    appId: null,
    pageId: null,
    link: null,
  },

  google: {
    searchId: null,
    trackingId: 'G-RQMPYGYP67',
  },

  youtube: {
    link: null,
  },

  instagram: {
    link: null,
  },

  whatsapp: {
    number: null,
    link: null,
  },
};

export default configSocial;
